import { takeEvery, put, call } from 'redux-saga/effects';
import type { SagaReturnType } from 'redux-saga/effects';
import {
  AuthActions,
  facilityAction,
  TherapistAction,
  commonActions,
} from '../../actions/constant';
import authService from '../../../services/apiServices/authService';
import jwtDecode from 'jwt-decode';
import { setFacilityId } from 'src/hooks/use-facility-id';

const {
  THERAPIST_LOGIN_REQUEST,
  THERAPIST_LOGIN_SUCCESS,
  THERAPIST_LOGIN_FAILURE,
  THERAPIST_FACILITY_NOT_FOUND,
  TOKEN_FIRST_TIME,
  THERAPIST_LOGOUT_RESET,
} = AuthActions;

const { STORE_FACILITY_UUID, PRE_GET_ASSIGNED_FACILITY_REQUEST } = facilityAction;
const { PRE_THERAPIST_PROFILE_REQUEST } = TherapistAction;
const { STORE_SUBDOMAIN_REDUX } = commonActions;

function* getTherapistLogin(action: any): SagaReturnType<any> {
  try {
    yield put({ type: THERAPIST_LOGOUT_RESET });
    const response = yield call(authService.therapistLogin, action.payload, action.subdomain);
    if (response?.status === 200) {
      const decodeToken: any = jwtDecode(`Bearer ${response.data.access_token}`);
      if (!decodeToken.lastLoggedInFacility) {
        yield put({ type: THERAPIST_FACILITY_NOT_FOUND, payload: response.data });
      } else {
        setFacilityId(decodeToken.lastLoggedInFacility);
        yield put({ type: STORE_FACILITY_UUID, uuid: decodeToken.lastLoggedInFacility });
        const headers = {
          subdomain:
            window.location.hostname === 'localhost'
              ? localStorage.getItem('realm')
              : window.location.hostname.split('-')[0],
          token: response.data?.access_token,
          facilityId: decodeToken.lastLoggedInFacility,
        };
        yield put({
          type: PRE_GET_ASSIGNED_FACILITY_REQUEST,
          payload: headers,
        });
        yield put({ type: PRE_THERAPIST_PROFILE_REQUEST, payload: headers });
        yield put({
          type: STORE_SUBDOMAIN_REDUX,
          subdomain:
            window.location.hostname === 'localhost'
              ? localStorage.getItem('realm')
              : window.location.hostname.split('-')[0],
        });
        yield put({ type: THERAPIST_LOGIN_SUCCESS, payload: response.data });
        if (!action.isProfile) {
          yield put({ type: TOKEN_FIRST_TIME });
        }
      }
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: THERAPIST_LOGIN_FAILURE, payload: error });
  }
}

function* therapistLoginSaga() {
  yield takeEvery(THERAPIST_LOGIN_REQUEST, getTherapistLogin);
}

export default therapistLoginSaga;
